export default {
  main: {
    site_id: 1138,
    title: 'Terminal PRO',
    logoSize: 'big',
    staffPassword: '124578',
    signInType: 'cpf',
    cpfType: 'cpf',
    homeMediaSlides: [
      {
        type: 'sport',
        path: 'betting/prematch',
      },
      {
        type: 'boosted',
        path: 'betting/prematch/boosted/all/all',
      },
    ],
    websitePasswordHash: 'c62bf0196a255572a008b4d7c845b8345cfa3c8c1547858e18b2b81d667e3da6',
    mandatoryCasinoLogin: true,
    enableTicketPopupFlow: false,
    availableLanguages: {
      '@replace': true,
      spa: {
        short: 'ES',
        name: 'Esp',
        region: 'UnitedKingdom',
        order: 2,
      },
      eng: {
        short: 'EN',
        name: 'English',
        region: 'UnitedKingdom',
        order: 1,
      },
      por: {
        short: 'PT',
        name: 'Português',
        region: 'Portugal',
        order: 5,
      },
    },
  },
  env: {
    lang: 'por',
  },
  home: {
    grid: [
      ['shortpages', 'banner'],
      ['slider', 'banner'],
      ['comp', 'banner'],
    ],
    gridColumns: '3fr 1fr',
    gridRows: '5fr 24fr 10fr',
    liveGamesCount: 6,
    casinoGamesCount: 6,
  },
  betslip: {
    enableStickyMode: true,
  },
  splitScreen: false,
  disableCashoutInHeader: true,
  disableCashoutAfterLogin: true,
  showBalanceWithoutLogin: false,
  enableBoostedOdds: false,
  cashoutMethods: [
    {
      pic: 'pix.png',
      name: 'pix',
      service: 'PAYBROKERS',
      handlerPopup: 'POPUPS.CASHOUT_BY_PIX',
      isAmountEditable: true,
    },
    {
      pic: 'pix-safeway.png',
      name: 'pix-safeway',
      service: 'SAFEWAY',
      handlerPopup: 'POPUPS.CASHOUT_BY_PIX',
      isAmountEditable: true,
    },
  ],
  depositeServiceID: 10266,
  depositMethods: [
    {
      pic: 'pix.png',
      type: 'pix',
      service: 'PAYBROKERS',
      handlerPopup: 'POPUPS.DEPOSIT_BY_PIX',
      minAmount: 20,
      enabled: true,
    },
    {
      pic: 'pix-safeway.png',
      type: 'pix-safeway',
      service: 'SAFEWAY',
      handlerPopup: 'POPUPS.DEPOSIT_BY_PIX',
      minAmount: 20,
      enabled: true,
    },
  ],
  disableDepositAfterLogin: false,
  routes: [
    {
      name: 'Betting',
      url: 'betting/prematch/all',
      type: 'sportsBook',
      enabled: true,
      nestedItems: [
        {
          url: 'betting/live/all',
          type: 'live',
          name: 'Live',
          enabled: true,
          icon: 'circle',
        },
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'Sports',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
        {
          url: 'betting/prematch/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
        {
          url: 'betting/results',
          name: 'Results',
          type: 'results',
          enabled: true,
          icon: '',
        },
      ],
    },
    {
      name: 'Casino',
      url: 'casino',
      type: 'casino',
      enabled: true,
    },
    {
      url: 'tickets',
      name: 'Tickets',
      enabled: true,
    },
  ],
  defaultTerminalParams: {
    pid: 18750659,
    tid: 30284,
    token: 'Fb89DQ==',
    currency: 'BRL'
  },

  sportsbook: {
    sportList: {
      enablePredefinedMultiples: false
    }
  }
};
